import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPortalActivePage, setAppBarStatus } from "../../modules/auth/actions";

export const useSettings = (initActivePage) => {
  const { activePage, pageTitle, showAppBar } = useSelector((state) => {
    return {
      activePage: state.auth.activePage,
      pageTitle: state.auth.pageTitle,
      showAppBar: state.auth.showAppBar,
    };
  });

  const dispatch = useDispatch();
  const getActivePage = () => {
    return activePage;
  };
  const getPageTitle = () => {
    return pageTitle;
  };
  const setActivePage = (pageKey, pageTitle) => {
    dispatch(setPortalActivePage({ activePage: pageKey, pageTitle: pageTitle }));
  };

  const setShowAppBar = (flag) => {
    dispatch(setAppBarStatus({ showAppBar: flag }));
  };
  const getShowAppBar = () => showAppBar;
  useEffect(() => {
    return () => {
      /*=================================================================================
       ANCHOR On unmount flush the title settings
      ===================================================================================*/
      setActivePage("", "");
    };
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  return {
    getActivePage,
    setActivePage,
    getPageTitle,
    setShowAppBar,
    getShowAppBar,
  };
};
export default useSettings;
